<template>
    <div v-if="acceptingNewPatients">
      <hp5-spacing-vertical sm="sm"></hp5-spacing-vertical>
      <hp5-semantic size-selection="xs">
        <span class="acceptingPatients"><hp5-icon name="system-success-base" size="xs" /> Accepting new patients</span>
      </hp5-semantic>
    </div>
</template>
<script setup>

    const props = defineProps({
        location: Object
    })
    const acceptingNewPatients = computed(() => props.location.acceptingNewPatients)

</script>
  
  <style lang="scss" scoped>
  .acceptingPatients {
    display: flex;
    align-items: center;
  }
  
  hp5-icon {
    margin-right: var(--spacing-xxs);
  }
  </style>